"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    subscribe: ()=>subscribe,
    updateCard: ()=>updateCard,
    cancelSubscription: ()=>cancelSubscription,
    useSubscribe: ()=>useSubscribe,
    useUpdateCard: ()=>useUpdateCard,
    useCancelSubscription: ()=>useCancelSubscription
});
const _reactQuery = require("react-query");
const _ = require("../..");
const subscribe = (payload, opts)=>{
    return _.api.post(`native_app/v2/members/subscribe`, payload, opts);
};
const updateCard = (payload, opts)=>{
    return _.api.put(`native_app/v2/members/update_subscription`, payload, opts);
};
const cancelSubscription = (payload, opts)=>{
    return _.api.post(`native_app/v2/members/cancel_subscription`, payload, opts);
};
const useSubscribe = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>subscribe(payload), {
        ...queryOptions
    });
};
const useUpdateCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updateCard(payload), {
        ...queryOptions
    });
};
const useCancelSubscription = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>cancelSubscription(payload), {
        ...queryOptions
    });
};
